import { createContext, PropsWithChildren, useMemo } from 'react'
import { AutomationComplex } from '../pages/Automations/AutomationTypes'
import { useQuery } from '@tanstack/react-query'
import { DAIRequest } from '../utils/DAIRequest'

type AutomationContextType = {
  loading: boolean
  automations: AutomationComplex[]
  triggers: Trigger[]
}

const AutomationContext = createContext<AutomationContextType | undefined>(
  undefined
)

type Trigger = {
  id: string
  name: string
}

export const AutomationContextProvider = ({ children }: PropsWithChildren) => {
  const { data: automations, isLoading: loadingAutomations } = useQuery<
    AutomationComplex[]
  >({
    queryKey: ['automations'],
    queryFn: async () => {
      return (await DAIRequest('GET', '/api/v1/automations/getAutomations'))
        .data.automations
    },
  })

  const { data: triggers, isLoading: loadingTriggers } = useQuery<Trigger[]>({
    queryKey: ['triggers'],
    queryFn: async () => {
      return (await DAIRequest('GET', '/api/v1/triggers/getTriggers')).data
    },
  })

  const isLoading = useMemo(
    () => loadingAutomations || loadingTriggers,
    [loadingAutomations, loadingTriggers]
  )

  return (
    <AutomationContext.Provider
      value={{
        loading: isLoading,
        automations: automations ?? [],
        triggers: triggers ?? [],
      }}
    >
      {children}
    </AutomationContext.Provider>
  )
}

export default AutomationContext
